var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContentPublic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 30,
    viewBox: "0 0 46 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 30,
    rx: 2,
    fill: "#CCE0FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8281 17.125C18.8594 17.125 20.7656 18.0781 20.7812 19.7188C20.7656 21.3438 18.8594 22.3125 15.8281 22.2969C12.8281 22.3125 10.9062 21.3438 10.9062 19.7188C10.9062 18.0781 12.8281 17.125 15.8281 17.125ZM15.8281 18.25C13.7031 18.25 12.375 18.7969 12.3906 19.7188C12.375 20.625 13.7031 21.1562 15.8281 21.1562C17.9688 21.1562 19.2969 20.625 19.3125 19.7188C19.2969 18.7969 17.9688 18.25 15.8281 18.25ZM20.6719 9.01562V10.1875C20.6719 11.3125 20.6719 12.4688 20.2812 13.9062L18.8281 13.75C19.2031 12.3203 19.2031 11.2891 19.2031 10.2031H11.0156V9.01562H20.6719ZM22.2656 14.7656V15.9688H9.53125V14.7656H14.6406V12.1406H16.0938V14.7656H22.2656ZM34.9281 8.32812V22.3281H33.5063V15.0625H31.7719V21.6562H30.3813V8.70312H31.7719V13.8594H33.5063V8.32812H34.9281ZM28.9906 10.1094C28.975 13.7969 27.7563 17.0938 23.7563 19.3594L22.8969 18.3281C26.0063 16.5703 27.3188 14.1875 27.5531 11.3281H23.4906V10.1094H28.9906Z",
    fill: "#0066FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentPublic);
export default __webpack_public_path__ + "static/media/content-public.22c4ab2493854cf25abc867deaee8403.svg";
export { ForwardRef as ReactComponent };